var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5103 1.47226C19.1839 1.1496 18.7916 0.988281 18.3334 0.988281H1.66665C1.20833 0.988281 0.816088 1.14956 0.489514 1.47226C0.163123 1.795 0 2.18281 0 2.63599V15.1593C0 15.6126 0.163123 16.0004 0.489514 16.3231C0.816088 16.6458 1.20833 16.8072 1.66665 16.8072H18.3334C18.7916 16.8072 19.1839 16.6458 19.5103 16.3231C19.8367 16.0005 20 15.6126 20 15.1593V2.63599C20 2.18281 19.8367 1.795 19.5103 1.47226ZM18.6665 15.1596C18.6665 15.2489 18.6336 15.326 18.5676 15.3914C18.5017 15.4563 18.4235 15.4889 18.3334 15.4889H1.66665C1.57643 15.4889 1.49828 15.4563 1.43231 15.3911C1.36639 15.3257 1.33337 15.2487 1.33337 15.1593V8.89774H18.6666V15.1596H18.6665ZM18.6665 4.94281H1.33333V2.63585C1.33333 2.5466 1.36624 2.46952 1.43228 2.40415C1.49828 2.33912 1.57643 2.30647 1.66662 2.30647H18.3333C18.4235 2.30647 18.5016 2.33897 18.5676 2.40415C18.6335 2.46952 18.6665 2.5466 18.6665 2.63585V4.94281H18.6665Z",
    fill: "#43B02A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33362 12.8525H2.66699V14.1709H5.33362V12.8525Z",
    fill: "#43B02A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6669 12.8525H6.66699V14.1709H10.6669V12.8525Z",
    fill: "#43B02A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCard);
export default __webpack_public_path__ + "static/media/new-card.ae925343a53289de15cb1c4738ef18a2.svg";
export { ForwardRef as ReactComponent };